import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { QrReader } from 'react-qr-reader';
import Moment from 'moment';
import { Collapse, CardBody, Card, Button, Label, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup } from 'reactstrap';
import Services from './Services';
import RFForm from '../../components/Form/RFForm';
import RFField from '../../components/Form/RFField';
import CustomTooltip from '../../components/Tooltip/CustomTooltip';
import getTooltip from './JegyellenrozesTooltips';
import TimeFormatter from '../../commons/TimeFormatter';

class JegyellenorzesContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      baseJson: [],
      collapse: false,
      modal: false,
      result: 'No result',
      formCode: '',
      isKeyboardHidden: true,
      selected: [],
      kameraPreview: false,
      validatedTicketInfo: {
        err: undefined,
        msg: undefined,
        col: undefined,
        cbg: undefined,
        ico: undefined
      }
    };

    this.myInp = React.createRef();
  }

  componentDidMount() {
    this.listEsemenyek();
    window.setTimeout(() => {
      this.focusKeyboard(this.state.isKeyboardHidden);
      document.body.classList.remove("sidebar-mobile-show");
    }, 500);
    this.getKameraPreview();
  }

  toggleCollapse = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  }

  getKameraPreview = () => {
    Services.kameraPreview((err, res) => {
      if (!err) {
        this.setState({ kameraPreview: res[0] == true });
      }
    });
  }

  listEsemenyek = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listEsemenyek((err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
            selected: res[0].map(s => s.eid),
            expanded: []
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  // componentDidUpdate(prevProps) {
  //   // Typical usage (don't forget to compare props):
  //   console.log(prevProps, this.props);
  //   if (this.props.active !== prevProps.active) {
  //     if (this.props.active) {
  //       this.listEsemenyek();
  //       window.setTimeout(() => {
  //         this.focusKeyboard(this.state.isKeyboardHidden);
  //       }, 500);
  //     }
  //   }
  // }

  handleScan = data => {
    let lastValue = JSON.parse(JSON.stringify(this.state.formCode));
    if (data && (lastValue !== this.state.formCode)) {
      this.setState({
        formCode: data
      }, () => {
        this.validateTicket();
      })
    }
  }

  handleError = err => {
    console.error(err)
  }

  focusKeyboard = (isKeyboardHidden) => {
    if(isKeyboardHidden) {
      this.myInp.current.readonly = true;
      this.myInp.current.readOnly = true;
      this.myInp.current.focus();
      window.setTimeout(() => {
      //this.myInp.current.blur() 
      this.myInp.current.readonly = false
      this.myInp.current.readOnly = false }, 50);
    } else {
      this.myInp.current.readOnly = false;
      this.myInp.current.readonly = false;
      this.myInp.current.focus();
    }
  }

  validateTicket = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.validateTicket(this.state.formCode, this.state.selected, (err, res) => {
      if (!err) {
        this.setState({
          validatedTicketInfo: res[0],
          deleteButtonLoading: false
        }, () => {
          this.setState({
            modal: true
          }, () => {
            window.setTimeout(() => {
              this.setState({
                modal: false,
                formCode: '',
              }, () => {
                this.focusKeyboard(this.state.isKeyboardHidden);
              })
            }, 1500);
          })
        });
      } else {
        this.setState({
          deleteButtonLoading: false,
          formCode: ''
        }, () => {
          this.focusKeyboard(this.state.isKeyboardHidden);
        });
      }
    });
  }

  renderEsemenyek = () => {
    return this.state.baseJson.map((item) => (
      <Card
        style={{
          color: this.isSelected(item) ? '#fff' : 'gray',
          backgroundColor: this.isSelected(item) ? '#56ce90' : '#fff',
          borderColor: this.isSelected(item) ? '#56ce90' : '#fff',
          marginTop: 20,
          paddingTop: 15,
          paddingBottom: 5,
          cursor: 'pointer'
        }}
        key={item.eid}
        onClick={() => {
          let clonedItem = JSON.parse(JSON.stringify(item));
          if(this.isSelected(clonedItem)) {
            this.setState({ selected: this.state.selected.filter(selectedItem => selectedItem !== item.eid), formCode: '' });
          } else {
            this.setState({
              selected: [...this.state.selected, item.eid],
              formCode: ''
            });
          }
          this.focusKeyboard(this.state.isKeyboardHidden);
        }}
      >
        <strong>{item.nam + ' - ' + item.hna}{item.pub ? "": <i className="fa fa-lock pull-right" aria-hidden="true" style={{ color: 'red' }} />}</strong>
        <p>{item.pro}</p>
        <p>{(item.sta ? TimeFormatter.formatLLLL(item.sta) : '')}</p>
      </Card>
    ))
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  onModalClose = () => {
    this.setState({
      formCode: '',
      modal: false
    })
  }

  isSelected = (item) => {
    let result = false;
    this.state.selected.forEach((eid) => {
      if(item.eid === eid) result = true;
    });
    return result;
  }

  toggleInputmode = () => {
    this.setState(prevState => ({
      isKeyboardHidden: !prevState.isKeyboardHidden,
      formCode: '',
    }), () => {
      this.focusKeyboard(this.state.isKeyboardHidden);
    });
  }

  render() {
    let cardStyle = {
      padding: 10
    };
    let qrReaderStyle = !this.state.kameraPreview ? { display: 'none' } : {};
    return (
      <React.Fragment>
      <div>
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            Jegyellenőrzés
            <CustomTooltip text={getTooltip('jegyellenorzes')} id="jegyellenorzesTT" />
            {/* <YouTube data={videoData} /> */}
          </div>
          <div style={cardStyle}>
          <div className="row justify-content-md-center">
          <div className="col-md-8">
            <Button block size="lg" onClick={this.toggleCollapse} style={{ color: 'white', backgroundColor: '#6c63ff', borderRadius: 0, marginTop: 24 }}>
              {'Esemény: ' + this.state.selected.length +  ' db'}
              <i style={{ paddingTop: 3 }} className={"pull-right fa fa-arrow-" + (this.state.collapse ? 'down' : 'up')} aria-hidden="true" />
            </Button>
            <Collapse isOpen={this.state.collapse}>
              <Card style={{ borderRadius: 0, marginTop: 0, paddingTop: 0, textAlign:'center' }}>
                <CardBody>
                  {this.renderEsemenyek()}
                </CardBody>
              </Card>
            </Collapse>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-md-8" style={{ textAlign: 'center' }}>
            <div className="card" style={{ paddingTop: 20 }}>
              <div className="card-body">
                <h5 className="card-title">QR kód beolvasása</h5>
                <button onClick={this.toggleInputmode}>Billentyűzet: {this.state.isKeyboardHidden ? ' Elrejtve' : ' Megjelenítve'}</button>
                {/* <h6 className="card-subtitle mb-2 text-muted">Kód megadása</h6> */}
                <RFForm onSubmit={this.validateTicket}>
                  <>
                    <Label for="formCode" style={{ textAlign: 'left' }}>Jegy kód:</Label>
                    <input
                      size="30"
                      //inputMode={this.state.isKeyboardHidden ? 'none' : 'text'}
                      // autoFocus={true}
                      name="formCode"
                      className="jegy-input"
                      autoComplete="off"
                      value={this.state.formCode}
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 8, width: '100%', height: 'calc(1.5em + .75rem + 2px)', padding: '.375rem .75rem', lineHeight: '1.5' }}
                      onFocus={() => {
                        this.focusKeyboard(this.state.isKeyboardHidden);
                      }}
                      required
                      ref={this.myInp}
                      // ref={(ip) => this.myInp = ip}
                    />
                    <Button size="lg" block style={{  color: 'white', backgroundColor: '#6c63ff', marginBottom: 8 }}>Ellenőrzés</Button>
                  </>
                </RFForm>
                <QrReader
                  scanDelay={1000}
                  // onError={this.handleError}
                  resolution={1000}
                  // onScan={this.handleScan}
                  containerStyle={qrReaderStyle}
                  onResult={(result, error) => {
                    if (!!result) {
                      if (result.text !== this.state.formCode) {
                        this.setState({
                          formCode: result.text
                        }, () => {
                          this.validateTicket();
                        })
                      }
                    }
          
                    if (!!error) {
                      console.log(error);
                    }
                  }}
                  style={{ width: '100%' }}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg">
          <ModalBody
            onClick={this.onModalClose}
            style={{
              color: '#' + this.state.validatedTicketInfo.col,
              backgroundColor: '#' + this.state.validatedTicketInfo.cbg,
              textAlign: 'center',
              cursor: 'pointer'
            }}
          >
            <i className={this.state.validatedTicketInfo.ico} aria-hidden="true" style={{ fontSize: '50vw' }} />
            <p style={{ fontSize: 64 }}>{this.state.validatedTicketInfo.err}</p>
            <p style={{ fontSize: 32 }}>{this.state.validatedTicketInfo.msg}</p>
          </ModalBody>
        </Modal>
      </div>
      </div>
      </div>
      </div>
      </React.Fragment>
    )
  }
}

JegyellenorzesContent.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default JegyellenorzesContent;
